import noop from 'lodash/noop';
import type { State } from './types.tsx';

export const initialState: State = {
	isArchiveIssueModalOpen: false,
	issueKey: null,
	issueId: null,
	onIssueArchiveSuccess: null,
	onChildIssuesArchiveSuccess: null,
	onDeleteIssuesFromNINView: noop,
	onCloseIssueViewModal: null,
	triggerPointKey: null,
	workType: null,
};
